/*
  st-cart.js: shared cart helpers (loaded in layout/theme.liquid).

  STCart.addItems(items) → Promise
    One atomic POST to /cart/add.js with { items: [...] }. If any item fails
    (sold out, quantity limit, unavailable add-on) Shopify rejects the whole request
    with a 422, nothing is added, and the promise rejects with Shopify's message.
    This replaces the old one-request-per-item queue, which swallowed errors.

  STCart.markBusy($buttons, label) / STCart.showError($buttons, message)
    Button-state helpers for add-to-cart buttons.

  STCart.formatMoney(cents)
    Formats cents with the shop's money format (window.STMoneyFormat, set in theme.liquid).
*/
(function () {
  if (window.STCart) return;

  function formatMoney(cents) {
    var format = window.STMoneyFormat || '${{amount}}';
    var value = (Number(cents) || 0) / 100;
    function withDelimiters(number, decimals, thousands, decimal) {
      var parts = number.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimals ? decimal : '');
    }
    var out = format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelimiters(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelimiters(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelimiters(value, 2, "'", '.');
        default: return withDelimiters(value, 2, ',', '.');
      }
    });
    // match the theme's Liquid output: `money | remove: ' '`, no HTML
    return out.replace(/<[^>]*>/g, '').replace(/\s/g, '');
  }

  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        if (!res.ok) {
          var err = new Error(data.description || data.message || 'Sorry, we couldn’t add that to your cart. Please try again.');
          err.status = res.status;
          throw err;
        }
        return data;
      });
    });
  }

  function markBusy($buttons, label) {
    $buttons.each(function () {
      var $b = window.jQuery(this);
      if ($b.data('st-label') === undefined) $b.data('st-label', $b.text());
    });
    $buttons.next('.add-to-cart-error').remove();
    $buttons.text(label || 'Adding...');
  }

  function showError($buttons, message) {
    $buttons.removeClass('success').each(function () {
      var $b = window.jQuery(this);
      $b.text($b.data('st-label') || 'Add to cart');
    });
    $buttons.next('.add-to-cart-error').remove();
    // Show it under the main form's button (the first match), not the sticky bar's copy.
    $buttons.first().after(
      window.jQuery('<p class="add-to-cart-error" role="alert"></p>').text(message)
    );
  }

  window.STCart = {
    addItems: addItems,
    markBusy: markBusy,
    showError: showError,
    formatMoney: formatMoney
  };
})();
